import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ZonaExtendidaTarifaPrecioDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Nombre", cell: x => ({ data: x.Nombre }) }, 
    { title: "Precio por sobre", cell: x => ({ data: x.PrecioSobre, view: kea.formatCurrency }) }, 
    { title: "Precio por kg. excedente", cell: x => ({ data: x.PrecioKgExcedente, view: kea.formatCurrency }) }, 
];

/**Obtiene las columnas del grid */
export function columnas(deps: kea.BotonesListaDeps<Entity>): Column[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [botones, ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifasprecio/list/columns.tsx